// Mock fallback data (mirrors backend default_config.py).
// Real data is loaded from /api/site-config via SiteContext.

export const defaultSiteData = {
  branding: {
    logoText: 'GAMEX',
    logoAccent: 'HUB',
    logoImage: '',
    tagline: 'BUILD - LAUNCH - SCALE',
    headerBg: '#777544',
    pageBg: '#0a0a0a',
    accent: '#d4d77a',
    accentDark: '#9ea253',
    activeGreen: '#4a5d23',
    favicon: ''
  },
  header: {
    bgColor: '#777544',
    navBg: '#3e3d26',
    searchPlaceholder: 'Search Events(At least 3 letters)...',
    showClock: true,
    showLogin: true,
    showSignup: true,
    showGetB2B: true,
    showGetB2C: true,
    showGetId: true,
    loginLabel: 'Login',
    registerLabel: 'Signup'
  },
  navigation: [],
  sidebar: [],
  heroSlides: [],
  gameCards: [],
  promo: { title: '', gradient: 'linear-gradient(90deg, #ff7a00 0%, #ffb04a 100%)', link: '#' },
  features: [],
  originalsTabs: [],
  originalsGames: [],
  inPlayMatches: [],
  rightPanel: { tab1Label: 'My Interests', tab2Label: 'Recent', emptyText: '', loginLink: 'Login' },
  loginModal: {},
  signupModal: {},
  whatsappLink: 'https://wa.me/919999999999',
  social: { whatsapp: '', telegram: '', instagram: '', youtube: '' },
  footer: { aboutTitle: '', aboutText: '', columns: [], copyright: '' },
  products: [],
  productsEnabled: true,
  // Main page section display order (can be rearranged by Admin)
  sectionOrder: [
    'hero',
    'marquee',
    'gamecards',
    'promotions',
    'features',
    'products',
    'exchanges',
    'dealingTerms',
    'paymentsWeAccept',
    'topRated',
    'originals',
    'inplay'
  ],
  // Global per-section visibility toggles (Admin → Section Visibility)
  sectionVisibility: {
    hero: true, marquee: true, gamecards: true, promotions: true, features: true,
    products: true, exchanges: true, dealingTerms: true, paymentsWeAccept: true,
    topRated: true, originals: true, inplay: true, floatingSocial: true, rightSidebar: true
  },
  // Hero slider extra controls
  heroSliderControls: false, // when false, chevrons + dots are hidden
  // Dealing Terms (Chiraag-style)
  dealingTerms: {
    enabled: true,
    title: 'DEALING TERMS',
    accentColor: '#0ea560',
    rows: [
      { id: 'dt1', label: 'Min Refill', value: '1 Lac Points' },
      { id: 'dt2', label: 'Min Withdrawal', value: '1 Lac Points' },
      { id: 'dt3', label: 'Max Process Time', value: '30 minutes' },
      { id: 'dt4', label: 'Timings', value: '24 hours' },
      { id: 'dt5', label: 'Days', value: '365 days' }
    ]
  },
  // Payments we accept
  paymentsWeAccept: {
    enabled: true,
    title: 'PAYMENT WE ACCEPT',
    logos: []
  },
  exchangeListings: {
    enabled: true,
    title: 'EXCHANGES AVAILABLE',
    subtitle: 'All types of exchanges — IDs & white labels with live demo access',
    whatsapp: '',
    accentColor: '#ccc77d',
    rateColor: '#ccc77d',
    b2bColor: '#ccc77d',
    b2cColor: '#ccc77d',
    popularColor: '#fbbf24',
    types: [
      {
        id: 'b2c',
        label: 'B2C',
        items: [
          { id: 'b2c_1', name: 'Lotus 1', rate: '16%', type: 'B2C', popular: true, rating: '5.0', reviews: '1.4k', description: 'Lotus Exchange Theme 1 — Cricket, Live Casino & Sportsbook', logo: '', link: 'https://lotusdemo1.com/' },
          { id: 'b2c_2', name: 'Lotus 2', rate: '16%', type: 'B2C', rating: '4.9', reviews: '890', description: 'Lotus Exchange Theme 2 — High Speed Sports Exchange', logo: '', link: 'https://lotusdemo2.com/' },
          { id: 'b2c_3', name: 'SouthWin', rate: '16%', type: 'B2C', rating: '4.8', reviews: '720', description: 'SouthWin Exchange — Premium Sportsbook & Casino', logo: '', link: 'https://southwindemo.com/' },
          { id: 'b2c_4', name: 'UltraWin 1', rate: '16%', type: 'B2C', rating: '4.9', reviews: '1.1k', description: 'UltraWin Sports Platform — Instant IDs & Live Odds', logo: '', link: 'https://ultrawindemo1.com/' },
          { id: 'b2c_5', name: '99Exch', rate: '16%', type: 'B2C', popular: true, rating: '5.0', reviews: '2.3k', description: '99 Exchange — India Top Sports & Cricket Exchange', logo: '', link: 'https://99exchdemo.com/' },
          { id: 'b2c_6', name: 'SkyExch 1', rate: '16%', type: 'B2C', popular: true, rating: '5.0', reviews: '1.8k', description: 'Sky Exchange Theme 1 — Premium Betting & Casino', logo: '', link: 'https://skyexchdemo1.com/' },
          { id: 'b2c_7', name: 'WinBuzz 1', rate: '16%', type: 'B2C', popular: true, rating: '4.9', reviews: '1.6k', description: 'WinBuzz Exchange — Fastest Live Betting Platform', logo: '', link: 'https://winbuzzdemo1.com/' },
          { id: 'b2c_8', name: 'Tiger 1', rate: '16%', type: 'B2C', rating: '4.8', reviews: '950', description: 'Tiger Exchange Theme 1 — Multi-market Live Exchange', logo: '', link: 'https://tigerdemo1.com/' },
          { id: 'b2c_9', name: '20Wicket', rate: '16%', type: 'B2C', rating: '4.7', reviews: '640', description: '20Wicket Exchange — Dedicated Cricket & Sportsbook', logo: '', link: 'https://20wicketdemo.com/' },
          { id: 'b2c_10', name: 'FairPlay', rate: '16%', type: 'B2C', popular: true, rating: '5.0', reviews: '3.1k', description: 'FairPlay Theme — World Class Live Casino & Exchange', logo: '', link: 'https://fairplaydemo.com/' },
          { id: 'b2c_11', name: '11xPlay', rate: '16%', type: 'B2C', rating: '4.8', reviews: '810', description: '11xPlay Exchange — Seamless UI with 100+ Casino Games', logo: '', link: 'https://11xplaydemo.com/' },
          { id: 'b2c_12', name: 'ReddyBook 1', rate: '16%', type: 'B2C', popular: true, rating: '5.0', reviews: '2.5k', description: 'ReddyBook Theme 1 — Leading Club & Sports Book', logo: '', link: 'https://reddybookdemo1.com/' },
          { id: 'b2c_13', name: 'AllPanel', rate: '16%', type: 'B2C', rating: '4.9', reviews: '1.3k', description: 'AllPanel Exchange — Master, Admin & User Panel Demo', logo: '', link: 'https://allpaneldemo.com/' },
          { id: 'b2c_14', name: 'Laser 247', rate: '16%', type: 'B2C', rating: '4.8', reviews: '920', description: 'Laser247 Theme — 24/7 Cricket & Live Table Games', logo: '', link: 'https://laserdemo.co/' },
          { id: 'b2c_15', name: 'Deal Demo', rate: '16%', type: 'B2C', rating: '4.7', reviews: '560', description: 'Deal Demo Exchange — Direct Line & Coin Deals', logo: '', link: 'https://dealdemo.co/' },
          { id: 'b2c_16', name: 'Reddy South', rate: '16%', type: 'B2C', rating: '4.9', reviews: '1.0k', description: 'Southern Club & High Roller Sportsbook', logo: '', link: 'https://reddysouth.com/' },
          { id: 'b2c_17', name: 'All Khiladi', rate: '16%', type: 'B2C', rating: '4.8', reviews: '780', description: 'All Khiladi Exchange — The Ultimate Indian Sports Platform', logo: '', link: 'https://allkhiladi.com/' }
        ]
      },
      {
        id: 'b2b',
        label: 'B2B',
        items: [
          { id: 'b2b_1', name: '4Wicket', rate: '16%', type: 'B2B', popular: true, rating: '5.0', reviews: '1.9k', description: 'Distributor & Master Super Admin Portal', logo: '', link: 'https://www.4wicket.com/' },
          { id: 'b2b_2', name: 'RadheExch 247', rate: '16%', type: 'B2B', rating: '4.8', reviews: '840', description: 'Radhe 247 Agent & Master Network Panel', logo: '', link: 'https://radheexch247.com/' },
          { id: 'b2b_3', name: 'AllPanel Buzz', rate: '16%', type: 'B2B', popular: true, rating: '5.0', reviews: '2.2k', description: 'AllPanel Master, Agent & Client Portal', logo: '', link: 'https://allpanel.buzz/' },
          { id: 'b2b_4', name: 'TigerExch Pro', rate: '16%', type: 'B2B', rating: '4.9', reviews: '1.1k', description: 'Tiger Pro Master Backend & Risk Management', logo: '', link: 'https://tigerexch.pro' }
        ]
      }
    ]
  },
  flyerAd: {
    enabled: true,
    mediaType: 'image',
    imageUrl: 'https://images.unsplash.com/photo-1518609878373-06d740f60d8b?w=800&auto=format&fit=crop&q=80',
    videoUrl: '',
    title: 'Welcome to Official Reddy Anna!',
    message: 'Get instant B2B Master Admin IDs & B2C User IDs with up to 16% Share Rate. Official 24/7 Verified Support.',
    ctaText: 'GET B2B & B2C ID NOW',
    ctaLink: '#exchanges',
    duration: 6,
    autoClose: true
  }
};

const STORAGE_KEY = `site_data_v4::${typeof window !== 'undefined' ? window.location.hostname : 'srv'}`;

export function loadSiteData() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null; // no cache → caller shows a loader until backend config arrives
    return { ...defaultSiteData, ...JSON.parse(raw) };
  } catch (e) {
    return null;
  }
}

export function saveSiteData(data) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function resetSiteData() {
  localStorage.removeItem(STORAGE_KEY);
}
